import {
  Box,
  Center,
  HStack,
  Icon,
  Link,
  ListItem,
  Stack,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { Link as LinkIcon } from '@cronos-app/icons';
import type { TSignature } from '@ui/locales/config';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import { LINK_MAP } from '../../core/configs/links';
import { CollapseWrapper } from './CollapseWrapper';

export const FAQs = () => {
  const t = useTranslations();
  return (
    <>
      <Stack gap="4" mt="40px" w="full">
        <Text
          textAlign="center"
          textStyle="h2"
          bg="gradients.white-blue-title"
          bgClip="text"
        >
          {t('card.FAQs')}
        </Text>
        {FAQ_LIST.map((item, index) => (
          <CollapseWrapper
            key={index}
            title={item.title(t)}
            titleProps={{
              textStyle: 'body1Bold',
              color: 'brand.white',
            }}
            iconProps={{
              color: 'brand.white',
              boxSize: '6',
            }}
          >
            <Box textStyle="body2" pt="2" pl="2">
              {item.content(t)}
            </Box>
          </CollapseWrapper>
        ))}
      </Stack>
      <Center mt="4">
        <Link href={LINK_MAP.gitbook()}>
          <HStack>
            <Text
              textStyle="body2Bold"
              color="brand.secondary-sky-blue"
              textAlign="center"
            >
              {t('card.Gitbook')}
            </Text>
            <Icon as={LinkIcon} boxSize="3" color="brand.secondary-sky-blue" />
          </HStack>
        </Link>
      </Center>
    </>
  );
};

const FAQ_LIST: {
  title: (t: TSignature) => ReactNode;
  content: (t: TSignature) => ReactNode;
}[] = [
  {
    title: (t) => t('card.qa-conoszk.q1'),
    content: (t) => t('card.qa-conoszk.a1'),
  },
  {
    title: (t) => t('card.qa-conoszk.q10'),
    content: (t) => t('card.qa-conoszk.a10'),
  },
  {
    title: (t) => t('card.qa-conoszk.q2'),
    content: (t) =>
      t.rich('card.qa-conoszk.a2', {
        a: (c) => (
          <Link
            href="https://cronos.org/card"
            isExternal
            color="brand.secondary-sky-blue"
          >
            {c}
          </Link>
        ),
      }),
  },
  {
    title: (t) => t('card.qa-conoszk.q3'),
    content: (t) =>
      t.rich('card.qa-conoszk.a3', {
        a: (c) => (
          <Link
            href="https://vvs.finance/"
            isExternal
            color="brand.secondary-sky-blue"
          >
            {c}
          </Link>
        ),
      }),
  },
  {
    title: (t) => t('card.qa-conoszk.q4'),
    content: (t) => t('card.qa-conoszk.a4'),
  },
  {
    title: (t) => t('card.qa-conoszk.q5'),
    content: (t) => t('card.qa-conoszk.a5'),
  },
  {
    title: (t) => t('card.qa-conoszk.q6'),
    content: (t) => (
      <>
        <Box>
          {t.rich('card.qa-conoszk.a6.p1', {
            a: (c) => (
              <Link
                href="https://cronos.org/explorer"
                isExternal
                color="brand.secondary-sky-blue"
              >
                {c}
              </Link>
            ),
          })}
        </Box>
        <Box mt="2">
          {t.rich('card.qa-conoszk.a6.p2', {
            a1: (c) => (
              <Link
                href="https://chat.crypto.com/"
                isExternal
                color="brand.secondary-sky-blue"
              >
                {c}
              </Link>
            ),
            a2: (c) => (
              <Link
                href="http://crofam.me/discord"
                isExternal
                color="brand.secondary-sky-blue"
              >
                {c}
              </Link>
            ),
          })}
        </Box>
        <UnorderedList mt="1" pl="2">
          <ListItem>{t('card.qa-conoszk.a6.l1')}</ListItem>
          <ListItem>{t('card.qa-conoszk.a6.l2')}</ListItem>
          <ListItem>{t('card.qa-conoszk.a6.l3')}</ListItem>
          <ListItem>{t('card.qa-conoszk.a6.l4')}</ListItem>
        </UnorderedList>
        <Box mt="2">{t('card.qa-conoszk.a6.p3')}</Box>
      </>
    ),
  },
  {
    title: (t) => t('card.qa-conoszk.q7'),
    content: (t) =>
      t.rich('card.qa-conoszk.a7', {
        a: (c) => (
          <Link
            href="https://help.crypto.com/en/collections/3374054-crypto-com-visa-card-fees-limits"
            isExternal
            color="brand.secondary-sky-blue"
          >
            {c}
          </Link>
        ),
      }),
  },
  {
    title: (t) => t('card.qa-conoszk.q8'),
    content: (t) =>
      t.rich('card.qa-conoszk.a8', {
        a: (c) => (
          <Link
            href="https://cronos.org/card"
            isExternal
            color="brand.secondary-sky-blue"
          >
            {c}
          </Link>
        ),
      }),
  },
  {
    title: (t) => t('card.qa-conoszk.q9'),
    content: (t) => t('card.qa-conoszk.a9'),
  },
];
